/*
Images need to be in public folder
*/
export const Work = [
    {
        When: "Oct 2021 - Present",
        Role: "Senior Software Engineer, Search / Product Data",
        Company: {
            Name: "Mercari Japan",
            Logo: "/images/mercari.png",
            URL: "https://jp.mercari.com/",
        },
        Description: [
            "Manage SKU metadata, which in turn is used to enhance search and recommendations.",
            "Design experiments and infrastructure to leverage crowd-sourced annotation into structured metadata.",
        ],
    },
    {
        When: "Oct 2019 - Oct 2021",
        Role: "Software Engineer, Search",
        Company: {
            Name: "Mercari US @Tokyo",
            Logo: "/images/mercari-us.jpeg",
            URL: "https://www.mercari.com/about/",
        },
        Description: [
            "Improve discovery of e-commerce listings via relevancy experiments",
            "Design & implement Search optimization projects for high-traffic, high availability microservices",
        ],
    },
    {
        When: "Jul 2019 - Sep 2019",
        Role: "Natural Language Processing Intern",
        Company: {
            Name: "Stride.AI, Bangalore",
            Logo: "/images/stride.png",
            URL: "https://stride.ai/",
        },
        Description: [
            "Developed Information Extraction pipelines to build Robotic Process Automation PoCs.",
            "Prototyped an automated Question Answer Generation (Natural Language Understanding) platform to identify areas of interest from contract forms",
        ],
    },
    {
        When: "May 2018 - Jul 2018",
        Role: "Software Engineer Intern",
        Company: {
            Name: "Schlumberger, Pune Technology Center",
            Logo: "/images/schlumberger.png",
            URL: "https://companies.naukri.com/putc-jobs/jobs/?id=112&srptemp=1&jdtemp=1&qp=PUTCNAUK",
        },
        Description: [
            "Developed RESTful backend API in C#, .NET to make existing computation engine accessible.",
            "Wrote a DLS-compliant Angular frontend for field experts in South-east Asia.",
        ],
    },
];
/**
 * Removed
    {
        When: "May 2017 - Jul 2017",
        Role: "Backend Developer Intern",
        Company: {
            Name: "Elanic, Bangalore",
            Logo: "/images/elanic.png",
            URL: "https://www.crunchbase.com/organization/elanic",
        },
        Description: [],
    },
 */
export default Work;